import { thanos26GetJson } from "./thanos26Client";

const URL_OFFER_ID = "manager/CreateId";

async function GetPhaseId(quoteId: string): Promise<any> {
    return thanos26GetJson(URL_OFFER_ID, { idtype: "2", quoteid: quoteId, taskid: "" });
}

async function GetTaskId(quoteId: string): Promise<any> {
    return thanos26GetJson(URL_OFFER_ID, { idtype: "3", quoteid: quoteId, taskid: "" });
}

async function GetQuoteId(): Promise<any> {
    return thanos26GetJson(URL_OFFER_ID, { idtype: "1" });
}

export async function GetTimeSafeTag(quoteId: string, taskId: string): Promise<any> {
    return thanos26GetJson(URL_OFFER_ID, { idtype: "4", quoteid: quoteId, taskid: taskId });
}

export default { GetTaskId, GetPhaseId, GetQuoteId, GetTimeSafeTag };
